import { Property } from "@/types/property";
import { startOfDay } from "date-fns";
import { useMemo } from "react";
import { useBatchedAvailability } from "../useBatchedAvailability";
import { useBlockDate } from "../useBlockDate";

export function useBlockedDates(properties: Property[]) {
  const { blockDate, unblockDate } = useBlockDate();
  const propertyIds = useMemo(() => properties.map((p) => p.id), [properties]);
  const batchedAvailability = useBatchedAvailability(propertyIds);

  const normalizeDate = (date: Date) => startOfDay(date).getTime();

  const isDateBlocked = (date: Date, propertyId: string): boolean => {
    const availability = batchedAvailability[propertyId];
    if (!availability?.unavailableDates || availability.isLoading) return false;
    const target = normalizeDate(date);
    return availability.unavailableDates.some(
      (d) => normalizeDate(d) === target,
    );
  };

  const refetchAllAvailability = () => {
    Object.values(batchedAvailability).forEach((a) => a?.refetch?.());
  };

  const handleBlockDate = (
    date: Date,
    property: Property,
    onUpdate?: () => void,
  ) => {
    const isBlocked = isDateBlocked(date, property.id);

    if (isBlocked) {
      unblockDate({ propertyId: property.id, date });
    } else {
      blockDate({ propertyId: property.id, date });
    }

    setTimeout(() => onUpdate?.(), 1000);
  };

  return {
    isDateBlocked,
    handleBlockDate,
    refetchAllAvailability,
  };
}
